// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MNX2PVD9TQHzJzMI5HrN{color:#005252;font-family:rubik,helvetica,arial,sans-serif;font-size:14px;font-style:normal;font-weight:normal;line-height:24px;text-align:center}.BLeyBk3TKGXb8GzkrlAA{color:#ee1a41}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"message": `MNX2PVD9TQHzJzMI5HrN`,
	"messageError": `BLeyBk3TKGXb8GzkrlAA`
};
export default ___CSS_LOADER_EXPORT___;
